// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"78af5232","453":"e943e638","732":"71879de7","977":"968fbe3c"}[chunkId] + ".chunk.js";
};